import store from '@/store';

export const appChat = {
  // Chat opened instance of Chat.js model
  instance: null,

  get isOpened() {
    return store.getters['chat/isOpened'];
  },

  get options() {
    return store.state.chat;
  },

  set(instance, options) {
    this.instance = instance;
    return store.dispatch('chat/SET_CHAT', options);
  },

  hide() {
    return this.set(null, { opened: false });
  },
};

export default {
  install(Vue) {
    Vue.prototype.$chat = appChat;
  },
};
